import { CheckCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import '../PaymentReleasedChatAlert/PaymentReleasedChatAlert.scss';

type PaymentTransferredChatAlertProps = {
	onFundsTransferredClick: () => void;
	disabled?: boolean;
	isMerchant: boolean;
};

function PaymentTransferredChatAlert({
	onFundsTransferredClick,
	disabled,
	isMerchant,
}: PaymentTransferredChatAlertProps) {
	const { t } = useTranslation();
	const titleKey = isMerchant ? 'transferFundsAlertTitleToClient' : 'transferFundsAlertTitleToMerchant';

	return (
		<div className='chat-payment-released-alert'>
			<CheckCircleOutlined className='chat-payment-released-alert__icon' />
			<div className='chat-payment-released-alert__content'>
				<p className='chat-payment-released-alert__title'>{t<string>(titleKey)}</p>
				<p className='chat-payment-released-alert__description'>{t<string>('transferFundsAlertDescription')}</p>
				<button
					type='button'
					className='chat-payment-released-alert__button'
					disabled={disabled}
					onClick={onFundsTransferredClick}
				>
					{t<string>('fundsTransferred')}
				</button>
			</div>
		</div>
	);
}

export default PaymentTransferredChatAlert;
